<template>
    <div class="podcast-list">
      <AudioPlayer
        v-for="(item, index) in list" :key="index"
        :item="item"
      ></AudioPlayer>      
      <button v-if="next" type="button" class="button" @click="loadMore">Load more</button>
    </div>
</template>

<script>
import AudioPlayer from './AudioPlayer.vue';
export default {
  props: [
    "url"
  ],
  components: {
    AudioPlayer
  },
  data () {
    return {
      links: [],
      list: [],
      next: ""
      
    }
  },

  mounted(){
      axios.get(this.url).then(response => {
        this.list = response.data.data
        this.next = response.data.links.next
      })
  },

  methods: {
    loadMore () {
      axios.get(this.next).then(response => {
        this.list = this.list.concat(response.data.data)
        this.next = response.data.links.next
      })
    },
    audioLink(index){
        return ".audio-wrap"+index;
    },

    audioClass(index){
        return "audio-wrap"+index;
    }
    
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Podcast.vue